<script setup>
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import Markdown from 'vue3-markdown-it'

const route = useRoute()
const loading = ref(false)
const page = ref({})
const requestPage = ref(null)
const slug = computed(() => route.params.slug)

function cancelPage() {
	if (requestPage.value) requestPage.value.cancel()
}
function getPage() {
	loading.value = true
	page.value = {}
	cancelPage()
	let axiosSource = axios.CancelToken.source()
	requestPage.value = { cancel: axiosSource.cancel }
	axios
		.get(`/api/page/${route.params.slug}`, {
			cancelToken: axiosSource.token,
		})
		.then((p) => {
			loading.value = false
			page.value = p.data
		})
		.catch((e) => {})
}
getPage()

watch(slug, async () => {
	getPage()
})
</script>

<template>
	<section class="container flex w-full flex-col gap-5 lg:w-half">
		<h1>{{ page.title }}</h1>
		<div class="h-[1px] w-full border-t border-dashed border-border" />
		<Markdown class="markdown legal" :source="page.body" :breaks="true" />
	</section>
</template>
